<div class="assessment-container">
  <div *ngIf="loading" class="loading">
    <mat-spinner diameter="40"></mat-spinner>
    <span>Lade Assessment...</span>
  </div>

  <div *ngIf="error" class="error">
    <mat-icon>error</mat-icon>
    <span>{{ error }}</span>
  </div>

  <div *ngIf="!loading && !error && assessment">
    <div class="assessment-header">
      <h1>{{ assessment.name }} ({{ assessment.shortName }})</h1>
      <p>{{ assessment.description }}</p>

      <div class="assessment-controls">
        <button mat-button *ngIf="assessment.guide" (click)="toggleGuide('assessment')" type="button">
          <mat-icon>{{ isGuideVisible('assessment') ? 'visibility_off' : 'help' }}</mat-icon>
          {{ isGuideVisible('assessment') ? 'Anleitung ausblenden' : 'Anleitung einblenden' }}
        </button>
        
        <!-- Neue Testbuttons -->
        <button mat-raised-button color="accent" (click)="setAllToMax()" type="button">
          <mat-icon>arrow_upward</mat-icon> Max überall
        </button>
        
        <!-- Toggle Button für alle Anleitungen -->
        <button mat-raised-button color="accent" (click)="toggleAllGuides()" type="button">
          <mat-icon>{{ allGuidesVisible ? 'visibility_off' : 'visibility' }}</mat-icon> 
          {{ allGuidesVisible ? 'Alle Anleitungen ausblenden' : 'Alle Anleitungen einblenden' }}
        </button>
      </div>

      <div *ngIf="isGuideVisible('assessment')" class="guide" [innerHTML]="assessment.guide"></div>
    </div>

    <form [formGroup]="form" (ngSubmit)="calculateAndSave()">
      <div formArrayName="groups">
        <div *ngFor="let group of assessment.groups; let groupIndex = index" class="group">
          <div class="group-header">
            <h2>{{ group.title }}</h2>
            <p *ngIf="group.description">{{ group.description }}</p>

            <button mat-button *ngIf="group.guide" (click)="toggleGuide(group.id)" type="button">
              <mat-icon>{{ isGuideVisible(group.id) ? 'visibility_off' : 'help' }}</mat-icon>
              {{ isGuideVisible(group.id) ? 'Anleitung ausblenden' : 'Anleitung einblenden' }}
            </button>

            <div *ngIf="isGuideVisible(group.id)" class="guide" [innerHTML]="group.guide"></div>
          </div>

          <div [formGroupName]="groupIndex" class="tasks">
            <div *ngFor="let task of group.tasks" class="task">
              <div class="task-header">
                <h3>{{ task.title }}</h3>
                <p *ngIf="task.description">{{ task.description }}</p>

                <button mat-button *ngIf="task.guide" (click)="toggleGuide(task.id)" type="button">
                  <mat-icon>{{ isGuideVisible(task.id) ? 'visibility_off' : 'help' }}</mat-icon>
                  {{ isGuideVisible(task.id) ? 'Anleitung ausblenden' : 'Anleitung einblenden' }}
                </button>

                <div *ngIf="isGuideVisible(task.id)" class="guide" [innerHTML]="task.guide"></div>
              </div>

              <!-- Eingabefelder basierend auf dem Inputtyp -->
              <div class="task-input">
                <!-- Seitenspezifische Eingaben, wenn nötig -->
                <ng-container *ngIf="assessment.sideType === sideTypeEnum.Both; else singleInput">
                  <div class="side-inputs">
                    <div class="side-input">
                      <h4>Links</h4>
                      <app-dynamic-input
                        [formControlName]="task.id + '_left'"
                        [inputType]="task.inputType"
                        [options]="task.options ?? []"
                        [min]="task.minValue"
                        [max]="task.maxValue"
                        [step]="task.step ?? 1"
                        [sortReversed]="task.sortOptionsReversed ?? false"
                        [guideVisible]="isGuideVisible(task.id)">
                      </app-dynamic-input>
                    </div>
                    <div class="side-input">
                      <h4>Rechts</h4>
                      <app-dynamic-input
                        [formControlName]="task.id + '_right'"
                        [inputType]="task.inputType"
                        [options]="task.options ?? []"
                        [min]="task.minValue"
                        [max]="task.maxValue"
                        [step]="task.step ?? 1"
                        [sortReversed]="task.sortOptionsReversed ?? false"
                        [guideVisible]="isGuideVisible(task.id)">
                      </app-dynamic-input>
                    </div>
                  </div>

                  <!-- Spezielle Konfigurationen (z.B. NHPT) -->
                  <ng-container *ngIf="task.specialConfig">
                    <div class="special-inputs" *ngFor="let config of getSpecialConfigEntries(task.specialConfig)">
                      <h4>{{ config.label }}</h4>
                      <app-dynamic-input
                        [formControlName]="task.id + '_' + config.key"
                        [inputType]="config.inputType"
                        [options]="config.options ?? []"
                        [min]="config.minValue"
                        [max]="config.maxValue"
                        [step]="config.step ?? 1"
                        [sortReversed]="config.sortOptionsReversed ?? false"
                        [guideVisible]="isGuideVisible(task.id)">
                      </app-dynamic-input>
                    </div>
                  </ng-container>
                </ng-container>

                <!-- Einzelne Eingabe ohne Seitenunterscheidung -->
                <ng-template #singleInput>
                  <app-dynamic-input
                    [formControlName]="task.id"
                    [inputType]="task.inputType"
                    [options]="task.options ?? []"
                    [min]="task.minValue"
                    [max]="task.maxValue"
                    [step]="task.step ?? 1"
                    [sortReversed]="task.sortOptionsReversed ?? false"
                    [guideVisible]="isGuideVisible(task.id)">
                  </app-dynamic-input>

                  <!-- Spezielle Konfigurationen (z.B. NHPT) -->
                  <ng-container *ngIf="task.specialConfig">
                    <div class="special-inputs" *ngFor="let config of getSpecialConfigEntries(task.specialConfig)">
                      <h4>{{ config.label }}</h4>
                      <app-dynamic-input
                        [formControlName]="task.id + '_' + config.key"
                        [inputType]="config.inputType"
                        [options]="config.options ?? []"
                        [min]="config.minValue"
                        [max]="config.maxValue"
                        [step]="config.step ?? 1"
                        [sortReversed]="config.sortOptionsReversed ?? false"
                        [guideVisible]="isGuideVisible(task.id)">
                      </app-dynamic-input>
                    </div>
                  </ng-container>
                </ng-template>
              </div>

              <!-- Ergebnisse anzeigen, wenn berechnet -->
              <div *ngIf="showResults && result" class="task-results">
                <!-- Für beidseitige Assessments beide Seiten anzeigen -->
                <ng-container *ngIf="assessment.sideType === sideTypeEnum.Both">
                  <div class="result-item" *ngIf="getTaskResult(task.id)?.leftPercentFulfillment !== undefined">
                    <span>Erfüllung Links:</span>
                    <strong>{{ getTaskResult(task.id)?.leftPercentFulfillment | number: '1.0-1' }}%</strong>
                  </div>
                  <div class="result-item" *ngIf="getTaskResult(task.id)?.rightPercentFulfillment !== undefined">
                    <span>Erfüllung Rechts:</span>
                    <strong>{{ getTaskResult(task.id)?.rightPercentFulfillment | number: '1.0-1' }}%</strong>
                  </div>
                </ng-container>
                
                <!-- Immer den Gesamtwert anzeigen -->
                <div class="result-item" *ngIf="getTaskResult(task.id)?.percentFulfillment !== undefined">
                  <span>Erfüllung{{ assessment.sideType === sideTypeEnum.Both ? ' Gesamt' : '' }}:</span>
                  <strong>{{ getTaskResult(task.id)?.percentFulfillment | number: '1.0-1' }}%</strong>
                </div>
                
                <div class="result-item" *ngIf="getTaskResult(task.id)?.icfScore !== undefined">
                  <span>ICF-Score:</span>
                  <strong>{{ getTaskResult(task.id)?.icfScore }}</strong>
                </div>
              </div>
            </div>
          </div>

          <!-- Gruppenergebnisse anzeigen, wenn berechnet -->
          <div *ngIf="showResults && result" class="group-results">
            <h3>Ergebnisse für {{ group.title }}</h3>
            <div class="result-item" *ngIf="getGroupResult(group.id)?.percentFulfillment">
              <span>Erfüllung:</span>
              <strong>{{ getGroupResult(group.id)?.percentFulfillment | number: '1.0-1' }}%</strong>
            </div>
            <div class="result-item" *ngIf="getGroupResult(group.id)?.icfScore !== undefined">
              <span>ICF-Score:</span>
              <strong>{{ getGroupResult(group.id)?.icfScore }}</strong>
            </div>
            <div *ngIf="getGroupResult(group.id)?.icfCategories?.length" class="icf-categories">
              <h4>ICF-Kategorien:</h4>
              <ul>
                <li *ngFor="let category of getGroupResult(group.id)?.icfCategories">
                  {{ category.code }}: {{ category.description }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- Gesamtergebnisse anzeigen, wenn berechnet -->
      <div *ngIf="showResults && result" class="assessment-results">
        <h2>Gesamtergebnis</h2>
        
        <!-- Patientendaten und Normwert-Informationen anzeigen -->
        <div *ngIf="result.appliedNormValue" class="norm-value-info">
          <h4>Verwendete Daten für die Berechnung:</h4>
          <div class="info-items">
            <div class="info-item">
              <span>Geschlecht:</span>
              <strong>{{ result.appliedNormValue.gender === 'male' ? 'Männlich' : (result.appliedNormValue.gender === 'female' ? 'Weiblich' : result.appliedNormValue.gender) }}</strong>
            </div>
            <div class="info-item">
              <span>Alter:</span>
              <strong>{{ result.appliedNormValue.age }} Jahre</strong>
            </div>
            <div class="info-item">
              <span>Normwert (Mittelwert):</span>
              <strong>{{ result.appliedNormValue.avgValue | number: '1.0-1' }}</strong>
            </div>
            <div class="info-item">
              <span>Standardabweichung:</span>
              <strong>{{ result.appliedNormValue.stdDeviation | number: '1.0-1' }}</strong>
            </div>
          </div>
        </div>
        
        <div class="result-item" *ngIf="result.percentFulfillment">
          <span>Erfüllung:</span>
          <strong>{{ result.percentFulfillment | number: '1.0-1' }}%</strong>
        </div>
        <div class="result-item" *ngIf="result.icfScore !== undefined">
          <span>ICF-Score:</span>
          <strong>{{ result.icfScore }}</strong>
        </div>
        
        <!-- ICF-Kategorien-Tabelle -->
        <div *ngIf="result.icfCategoryResults?.length" class="icf-categories-table">
          <h3>ICF-Kategorien Übersicht:</h3>
          <table>
            <thead>
              <tr>
                <th>ICF-Kategorie</th>
                <th>Beschreibung</th>
                <th>Erfüllung</th>
                <th>ICF-Score</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let category of result.icfCategoryResults">
                <td>{{ category.code }}</td>
                <td>{{ category.description }}</td>
                <td>{{ category.percentFulfillment | number: '1.0-1' }}%</td>
                <td>{{ category.icfScore }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <div *ngIf="result.icfCategories?.length" class="icf-categories">
          <h3>ICF-Kategorien:</h3>
          <ul>
            <li *ngFor="let category of result.icfCategories">{{ category.code }}: {{ category.description }}</li>
          </ul>
        </div>
        
        <!-- JSON-Debug-Ausgabe des gesamten Result-Objekts -->
        <div class="debug-json">
          <mat-accordion>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon>code</mat-icon> JSON-Debug-Ausgabe des Ergebnisses
                </mat-panel-title>
              </mat-expansion-panel-header>
              <pre class="json-output">{{ result | json }}</pre>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>

      <div class="form-actions">
        <button mat-button type="button" (click)="cancel()">Abbrechen</button>
        <button mat-raised-button color="primary" type="submit" [disabled]="false">
          {{ showResults ? 'Erneut berechnen' : 'Berechnen und speichern' }}
        </button>
      </div>
    </form>
  </div>
</div>
